import * as React from 'react';

import CloseIcon from '@mui/icons-material/Close';
import { Box, Chip, IconButton, Paper, Typography } from '@mui/material';
import ParamsPreview, {
  ParamsPreviewDiff,
} from 'components/ReportRequestV2/ParamsPreview';

import styles from '../ReportRequestV2.module.css';
import { SchemaIssue } from '../schema/validateParams';

interface Props {
  params: unknown;
  issues: SchemaIssue[];
  /** Differences from the cloned or updated report's params. */
  diff?: ParamsPreviewDiff;
  onHide: () => void;
}

/** Super admin only: the live params JSON and its schema validation, next to the form. */
const ReportJsonSidebar: React.FC<Props> = ({
  params,
  issues,
  diff,
  onHide,
}) => (
  <Paper
    variant="outlined"
    component="aside"
    aria-labelledby="report-json-title"
    className={styles.sidebar}
  >
    <Box className={styles.sidebarHeader}>
      <Typography
        id="report-json-title"
        variant="subtitle1"
        component="h2"
        fontWeight={600}
      >
        Report JSON
      </Typography>
      <Chip label="Super admin" size="small" variant="outlined" />
      <IconButton
        size="small"
        aria-label="Hide report JSON"
        onClick={onHide}
        sx={{ ml: 'auto' }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
    <ParamsPreview params={params} issues={issues} diff={diff} />
  </Paper>
);

export default ReportJsonSidebar;
